import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    downloadFail: 'Sending an SMS failed',
    downloadSucceed: 'Link successfully sent!',
  },

  fr: {
    downloadFail: 'L’envoi de SMS a échoué',
    downloadSucceed: 'Lien envoyé avec succès !',
  },
});

export default locales;
